import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Solar inverter
export const getSolarInverter = createAsyncThunk("/getlist-inverter", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-inverter`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log("response11", response)
        return response;
    } catch (error) {
        console.error('Error fetching inverter- ', error);
        throw error;
    }
})


